import { render, staticRenderFns } from "./PostNotice.vue?vue&type=template&id=0ea518fa&"
import script from "./PostNotice.vue?vue&type=script&lang=js&"
export * from "./PostNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports